<template>
    <!-- BEGIN: Content-->
    <div class="mt-0">
      <div class="flex">
        <div class="section_title"><span class="big-size weight-bold">{{ $store.state.loader_text }}&nbsp;&nbsp;</span>
          <div class="load"><v-progress-circular
            color="primary"
            indeterminate
            :size="18"
            :width="3"
            v-show="loader"
          ></v-progress-circular></div>
        </div>

        <div style="display:flex;align-items:center;justify-content:space-between;flex-direction:row">
          <v-text-field
                v-model="search"
                label="Search organisation"
                solo
                hide-details="auto"
                class="search_"
              ></v-text-field>
          <v-btn
            color="#000000"
            class="ma-1 white--text"
            depressed
            @click="editOrg(0)"
          >
            Organisation
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="orgList">
        <v-container fluid style="padding-top:0 !important;padding-bottom:0 !important">
          <v-row style="margin-top:0 !important;margin-bottom:0 !important">
            <v-col md="12" sm="12" class="my-1 py-0 px-0">
              <v-card class="card-shadow py-0">
                <v-card-text class="px-0 py-3 cardtext">
                    <div class="empty-state" v-if="allorgs.length === 0 && !loader">
                      <div class="empty-state__content">
                        <div class="empty-state__icon">
                          <v-img src="@/assets/icon.png" alt=""></v-img>
                        </div>
                        <div class="empty-state__message">No records available.</div>
                      </div>
                    </div>
                    <v-virtual-scroll
                      :items="allorgs"
                      :item-height="20"
                      renderless 
                      id="virtualscroll"
                      class="organisation"
                     >
                      <template v-slot:default="{ item }">
                          <div class="tcell">{{ item.name }}</div>
                          <div class="tcell">{{ item.email }}</div>
                       <!--    <div class="tcell">{{ item.telephone }}</div>
                          <div class="tcell">{{ item.address }}</div> -->
                          <div class="tcell">
                            <div v-if="item.vat === '1'">Include</div>
                            <div v-else>Exclude</div>
                          </div>
                          <div class="tcell">{{ item.projects_slug }}</div>
                          <div class="tcell">
                            <v-menu offset-x left bottom origin="center center" transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    small
                                    v-on="on">
                                  <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                                </v-btn>
                              </template>
                              
                              <v-list-item-group
                                color="primary"
                                class="actions"
                                >

                                  <v-list-item
                                    @click="editOrg(item.id)"
                                  >
                                      <v-list-item-icon>
                                        <v-icon color="#000000">mdi-pencil</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                        <v-list-item-title>Edit</v-list-item-title>
                                      </v-list-item-content>
                                  </v-list-item>

                                <v-list-item
                                  link
                                  @click="deleteItem(item.id)"
                                  >
                                      <v-list-item-icon>
                                        <v-icon>mdi-delete</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                        <v-list-item-title>Remove</v-list-item-title>
                                      </v-list-item-content>
                                </v-list-item>

                              </v-list-item-group>
                            </v-menu>
                          </div>
                      </template>
                    </v-virtual-scroll>

                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <!-- user update modal-->
        <v-dialog
          v-model="updatedialog"
          max-width="550px"
          >
          <v-card>

            <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

            <v-card-title>
              <span class="text-h6" v-if="item.updateID !== ''">Update Organisation</span>
              <span class="text-h6" v-else>Add Organisation</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        label="Name*"
                        v-model="item.updatename"
                        required
                        :rules="fieldRules"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        label="Email Address*"
                        required
                        v-model="item.updateemail"
                        :rules="emailRules"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        label="Telephone"
                        v-model="item.updatetelephone"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        label="Address"
                        v-model="item.updateaddress"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        label="KRA Pin"
                        v-model="item.updatekra"
                        hide-details
                      ></v-text-field>
                    </v-col>
                   <!--  <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-autocomplete
                        :items="otype"
                        label="Select type"
                        v-model="item.updatetype_id"
                        :value="item.updatetype_id"
                        item-text="type"
                        item-value="id"
                        :rules="fieldRules"
                        :search-input.sync="searchtype"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-autocomplete
                        :items="ocategory"
                        label="Select category"
                        v-model="item.updatecategory_id"
                        :value="item.updatecategory_id"
                        item-text="category"
                        item-value="id"
                        :rules="fieldRules"
                        :search-input.sync="searchcategory"
                      ></v-autocomplete>
                    </v-col> -->
                <!--     <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-autocomplete
                        :items="countries"
                        label="Select country"
                        v-model="item.updatecountry"
                        :value="item.updatecountry"
                        :rules="fieldRules"
                        :search-input.sync="searchcountry"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-autocomplete
                        :items="['Active', 'Inactive']"
                        label="Select status"
                        v-model="item.updatestatus"
                        :value="item.updatestatus"
                        :rules="fieldRules"
                        :search-input.sync="searchstatus"
                      ></v-autocomplete>
                    </v-col> -->
                   <!--  <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        label="Base Rate"
                        v-model="item.updatebase_amount"
                      ></v-text-field>
                    </v-col> -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        label="Projects Slug"
                        v-model="item.updateprojects_slug"
                        hide-details
                      ></v-text-field>
                    </v-col>

                  </v-row>
                  <v-row>
                    <v-col
                        cols="12"
                        sm="12"
                        md="6"
                      >
                        <v-switch
                          v-model="hasCodes"
                          label="Organisation Codes"
                          @change="onSwitchchange"
                          hide-details
                        ></v-switch>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="6"
                        >
                          <v-switch
                            v-model="mandatory"
                            label="Mandatory"
                            hide-details
                          ></v-switch>
                        </v-col>
                  </v-row>
                  <v-row v-if="hasCodes">
                   <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <v-text-field
                        label="Codes Sections"
                        v-model="item.updatecodes"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>

                    <v-col
                      cols="12"
                      sm="12"
                      md="5"
                    >
                      <v-switch
                        v-model="item.updateauthorize"
                        label="Authorize booking ?"
                        hide-details
                      ></v-switch>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                    >
                      <v-switch
                        v-model="item.updatevat"
                        label="VAT ?"
                        hide-details
                      ></v-switch>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                    >
                      <v-switch
                        v-model="item.updatenotification"
                        label="Notifications ?"
                        hide-details
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                hide-details
                  color="default darken-1"
                  text
                  @click="updatedialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="update"
                  v-if="item.updateID !== ''"
                >
                  Save
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="create"
                  v-else
                >
                  Save
                </v-btn>
            </v-card-actions>

          </v-form>
          </v-card>
        </v-dialog>
        <!-- update user -->
      </div>
    </div>

</template>
<style>
  .organisation .v-virtual-scroll__item{
    width:100%;
    display: grid !important;
     grid-template-columns: 20% 20% 20% 20% 20%;
     grid-auto-flow: column !important;
     grid-gap: 0px;
  }
</style>
<script>
import axios from 'axios'
import {ability} from '@/services/ability'
import $ from 'jquery';

export default {
    name:"orgList",
    components: { },
    data(){
        return {
          countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', `Timor L'Este`, 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'],
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
          ],
          searchfilter:'',
          search:"",
          valid: true,
          searchtype:null,
          searchcategory:null,
          searchcountry:null,
          searchstatus:null,
          hasCodes: false,
          mandatory: false,
          dialog: false,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Business Config',
              disabled: false,
              href: '',
            },
            {
              text: 'Organisations',
              disabled: false,
              href: '',
            },
            {
              text: 'List',
              disabled: false,
              href: '',
            },
          ],
          fields: [
            { text: 'Name', value: 'name' },
            { text: 'Email', value: 'email' },
            // { text: 'Telephone', value: 'telephone' },
            // { text: 'Address', value: 'address' },
            { text: 'Vat', value: 'vat' },
            { text: 'Project Slug', value: 'slug' },
            { text: 'Action', value: 'action' },
           ],
          item:{
              category_id:"",
              name:"",
              email:"",
              telephone:"",
              type_id:"",
              country:"",
              status:"",
              base_amount:0,
              one_trip_rate:"",
              round_trip_rate:"",
              projects_slug:"",
              address:"",
              authorize: false,

              updatecodes: "",

              updatecategory_id:"",
              updatename:"",
              updateemail:"",
              updatetelephone:"",
              updatetype_id:"",
              updatecountry:"",
              updatestatus:"",
              updatekra:"",
              updatebase_amount:0,
              updateone_trip_rate:"",
              updateround_trip_rate:"",
              updateprojects_slug:"",
              updateaddress:"",
              updateauthorize: null,
              updatevat: null,
              updatenotification: null,

              upcategory: '',
              upcatype: '',

              updateID: "",
              _method:"patch"
          },
            isBusy: false,
            loading: false,
           disabled: false,
           orgCategory: [],
           orgType: [],
           organisation: [],
           height: '100%',
            rowHeight: 25,
            perPage: 50,
            start: 0,
            timeout: null
        }
    },
    beforeMount() {
      if(!ability.can('organisation-management', 'all')) {
        this.$router.push({ name: 'Dashboard' })
        return
      }
    },
    mounted(){

      this.$store.state.loader_text = "Organisations"

      if(!this.orgs || this.orgs.length == 0) {
        this.getOrganisation()
      }

      let headertitle = `<div class="v-virtual-scroll__container"><div class="v-virtual-scroll__item" style="top: 0px;">`;
      this.fields.map(function(value, key) {
           headertitle +=`<div class="thead">${value.text}</div>`;
         });
      headertitle +=`</div></div>`;
      $('.v-virtual-scroll').prepend(headertitle)

    },
    serverPrefetch () {
      return this.getOrganisation()
    },
    computed: {
      orgs() {
        return this.$store.state.organisations.filter(item => {

          this.start = 0

          return item.name.toLowerCase().includes(this.search.toLowerCase())
        })
      },
      allorgs() {
        return this.orgs
      },
      otype() {
        return this.$store.state.orgtype
      },
      ocategory() {
        return this.$store.state.orgcategory
      },
      loader() {
        return this.$store.state.tableloader
      },
    },
    methods:{
      onSwitchchange($event) {
        if($event === true || $event === 'true' || $event === 'on') {
        }else {
          this.item.codes = ""
          this.mandatory = false
        }
      },
      getRowClass(item) {
        return 'row-color' 
      },
     getOrganisation(){
        this.$store.state.tableloader = true
        this.$store
          .dispatch('getOrganisation')
          .then(() => {
            this.$store.state.tableloader = false
          })
          .catch(() => {
            this.$store.state.tableloader = false
          })
      },
     create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.updatename)
            fd.append('email',this.item.updateemail)
            fd.append('address',this.item.updateaddress)
            fd.append('telephone',this.item.updatetelephone)
            fd.append('country',this.item.updatecountry)
            fd.append('category_id',this.item.updatecategory_id)
            fd.append('type_id',this.item.updatetype_id)
            fd.append('status',this.item.updatestatus)
            fd.append('kra',this.item.updatekra)
            fd.append('base_amount',this.item.updatebase_amount)
            fd.append('authorize',this.item.updateauthorize)
            fd.append('notification',this.item.updatenotification)
            fd.append('vat',this.item.updatevat)
            fd.append('one_trip_rate',this.item.updateone_trip_rate)
            fd.append('round_trip_rate',this.item.updateround_trip_rate)
            fd.append('projects_slug',this.item.updateprojects_slug)
            fd.append('codes',this.item.updatecodes)
            fd.append('hasCodes',this.hasCodes)
            fd.append('mandatory',this.mandatory)

            axios.post('/organisation', fd, config).then(response=>{
              this.loading = false
              this.disabled = false

              if(response.data.status === 200) {

                  let found = this.$store.state.organisations.find(data => data.id == response.data.organisation.id);
                  if (!found) {
                    this.$store.state.organisations.unshift(response.data.organisation)
                  }

                  this.$toast.success('Organisation added successfully','Success',{position: 'topRight',timeout: 7000,})
                }
                this.clear()
              this.item.updatetype_id = ''
              this.item.updatename = ''
              this.item.updateemail = ''
              this.item.updatetelephone = ''
              this.item.updateaddress = ''
              this.item.updatestatus = ''
              this.item.updatecategory_id = ''
              this.item.updatecountry = ''
              this.item.updateone_trip_rate = ''
              this.item.updateround_trip_rate = ''
              this.item.updatecodes = ''
              this.item.updatekra = ''
              this.item.updatebase_amount = 0
              this.item.updateauthorize = null
              this.item.updatevat = null
              this.item.updatenotification = null
              this.item.hasCodes = null
              this.item.mandatory = null
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
        clear () {
          if(this.$refs.form != undefined) {
            this.$refs.form.reset()
          }
        
        },
        async update(){

          if (this.$refs.form.validate()) {

            this.loading = true
            this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.updatename)
            fd.append('email',this.item.updateemail)
            fd.append('address',this.item.updateaddress)
            fd.append('telephone',this.item.updatetelephone)
            fd.append('country',this.item.updatecountry)
            fd.append('category_id',this.item.updatecategory_id)
            fd.append('type_id',this.item.updatetype_id)
            fd.append('status',this.item.updatestatus)
            fd.append('kra',this.item.updatekra)
            fd.append('base_amount',this.item.updatebase_amount)
            fd.append('authorize',this.item.updateauthorize)
            fd.append('notification',this.item.updatenotification)
            fd.append('vat',this.item.updatevat)
            fd.append('one_trip_rate',this.item.updateone_trip_rate)
            fd.append('round_trip_rate',this.item.updateround_trip_rate)
            fd.append('projects_slug',this.item.updateprojects_slug)
            fd.append('codes',this.item.updatecodes)
            fd.append('hasCodes',this.hasCodes)
            fd.append('mandatory',this.mandatory)
            fd.append('_method',this.item._method)

            await axios.post(`/organisation/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === 200) {

                  let index = this.$store.state.organisations.findIndex(data => data.id == response.data.organisation.id);
                  if (index > -1) {
                    this.$store.state.organisations.splice(index, 1, response.data.organisation);
                  }

                  this.$toast.success('Organisation updated successfully','Success',{position: 'topRight',timeout: 7000,})
                  this.updatedialog = false
                }
               
              this.item.updatetype_id = ''
              this.item.updatename = ''
              this.item.updateemail = ''
              this.item.updatetelephone = ''
              this.item.updateaddress = ''
              this.item.updatestatus = ''
              this.item.updatecategory_id = ''
              this.item.updatecountry = ''
              this.item.updatekra = ''
              this.item.updateone_trip_rate = ''
              this.item.updateround_trip_rate = ''
              this.item.updatecodes = ''
              this.item.updatebase_amount = 0
              this.item.updateauthorize = null
              this.item.updatevat = null
              this.item.updatenotification = null
              this.item.hasCodes = null
              this.item.mandatory = null
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
     editOrg(id) {
        let index = this.allorgs.filter(item => item.id === id )
        if(index.length > 0) {

          // this.item.updatetype_id = parseInt(index[0].orgtype.id)
          this.item.updatename = index[0].name
          this.item.updateemail = index[0].email
          this.item.updatetelephone = index[0].telephone
          this.item.updateaddress = index[0].address
          // this.item.updatestatus = index[0].status
          // this.item.updatecategory_id = parseInt(index[0].orgcategory.id)
          // this.item.updatecountry = index[0].country
          // this.item.updateone_trip_rate = index[0].one_trip_rate
          // this.item.updateround_trip_rate = index[0].round_trip_rate
          // this.item.updatebase_amount = index[0].base_amount
          this.item.updateprojects_slug = index[0].projects_slug
          this.item.updatecodes = index[0].codes
          this.item.updatekra = index[0].kra
          if(index[0].bookingauthorize == 1){
            this.item.updateauthorize = true
          }else {
            this.item.updateauthorize = null
          }
          if(index[0].vat == '1'){
            this.item.updatevat = true
          }else {
            this.item.updatevat = null
          }
          if(index[0].notifications == '1'){
            this.item.updatenotification = true
          }else {
            this.item.updatenotification = null
          }
          if(index[0].mandatory == '1'){
            this.mandatory = true
          }else {
            this.mandatory = null
          }
          if(index[0].hascodes == '1'){
            this.hasCodes = true
          }else {
            this.hasCodes = null
          }
          this.item.updateID = index[0].id
          this.updatedialog = true

        }else {
          this.item.updateID = ''
          this.updatedialog = true
          this.clear()
        }
        
      },
      deleteItem(id){
            if(confirm("Are you sure to delete organisation ?")){
                axios.delete(`/organisation/${id}`).then(response=>{
                  let index = this.$store.state.organisations.findIndex(data => data.id == response.data.organisation.id);
                  if (index > -1) {
                    this.$store.state.organisations.splice(index, 1);
                  }
                  this.$toast.success('Organisation deleted successfully','Success',{position: 'topRight',timeout: 7000,})
                }).catch(error=>{
                    console.log(error)
                })
            }
        }
    }
}
</script>